<template>
  <div class="vk-button-wrapper">
    <button class="vk-button social-button" @click="submit">
      <img src="@/assets/images/SignIn/vk.svg" alt="VK" />
    </button>
    <div id="vkid-container" style="display: none"></div>
  </div>
</template>

<script>
import './vkButton.styles.scss'

const VK_APP_ID = 54351604

export default {
  name: 'VkButton',

  data() {
    return {
      widgetInitialized: false
    }
  },
  mounted() {
    this.loadVKSDK()
  },

  beforeDestroy() {
    // Очистка при размонтировании
    const container = document.getElementById('vkid-container')
    if (container) {
      container.innerHTML = ''
    }
  },

  methods: {
    async loginViaVk(idToken) {
      try {
        const response = await fetch('https://users.backend-pier.com/api/v1/user/login-vk', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id_token: idToken })
        })

        const data = await response.json()

        if (data.auth_token && data.data) {
          // Авторизация через Vuex
          this.$store.dispatch('signIn', data)

          // Устанавливаем валюту и язык из ответа бэкенда
          if (data.data.currency) {
            this.$store.commit('setCurrency', data.data.currency.toLowerCase())
          }
          if (data.data.language) {
            this.$store.commit('setLanguage', data.data.language.toLowerCase())
          }

          // Аналитика
          if (this.$analytics) {
            this.$analytics.send('login', {
              type: 'login',
              method: 'vk',
              user_id: data.data?.user_id
            })
            this.$analytics.setUser(data.data?.user_id)
          }

          // Эмитим событие успешной авторизации родительскому компоненту
          this.$emit('auth-success', data)
        } else {
          console.error('VK auth failed:', data)
        }
      } catch (error) {
        console.error('Error during VK authentication:', error)
      }
    },

    vkidOnSuccess(data) {
      if (data.id_token) {
        this.loginViaVk(data.id_token)
      }
    },

    vkidOnError(error) {
      console.error('VK auth error:', error)
    },

    submit() {
      // Программно вызываем клик по VK виджету
      const vkButton = document.querySelector('#vkid-container button')
      if (vkButton) {
        vkButton.click()
      } else {
        console.error('VK виджет не найден')
      }
    },

    initVKWidget() {
      if (!window.VKIDSDK) {
        console.error('VK SDK еще не загружен')
        return
      }

      const VKID = window.VKIDSDK

      VKID.Config.init({
        app: VK_APP_ID,
        redirectUrl: 'https://rbxpier.me/',
        responseMode: 'callback',
        source: 'lowcode',
        scope: 'vkid.personal_info vkid.birthday vkid.gender'
      })

      const oneTap = new VKID.OneTap()

      const self = this

      oneTap
        .render({
          container: document.getElementById('vkid-container'),
          fastAuthEnabled: false,
          showAlternativeLogin: true,
          styles: {
            width: 40
          }
        })
        .on(VKID.WidgetEvents.ERROR, error => self.vkidOnError(error))
        .on(VKID.OneTapInternalEvents.LOGIN_SUCCESS, function(payload) {
          const code = payload.code
          const deviceId = payload.device_id

          console.log('VK LOGIN_SUCCESS event received:', {
            code: code ? 'present' : 'missing',
            deviceId: deviceId ? 'present' : 'missing'
          })

          VKID.Auth.exchangeCode(code, deviceId)
            .then(data => {
              console.log('Token exchange successful:', data)
              self.vkidOnSuccess(data)
            })
            .catch(error => {
              console.error('Token exchange failed:', error)
              self.vkidOnError(error)
            })
        })

      this.widgetInitialized = true
    },

    loadVKSDK() {
      // Проверяем, не загружен ли уже SDK
      if (window.VKIDSDK) {
        console.log('VK SDK already loaded, initializing widget')
        this.initVKWidget()
        return
      }

      const script = document.createElement('script')
      // SDK лежит у нас, а не на unpkg.com.
      //
      // С CDN его срезали блокировщики рекламы: запрос падал с
      // ERR_BLOCKED_BY_CLIENT, window.VKIDSDK оставался пустым, виджет не
      // рисовался, и клик по кнопке молча ничего не делал — вход через VK был
      // недоступен всем, у кого стоит блокировщик. Сам unpkg при этом жив:
      // дело в доменном правиле на стороне браузера, повлиять на него нельзя.
      // В инкогнито, где расширения выключены, вход работал — это и указало
      // на причину.
      //
      // В рантайме SDK ходит только на id.vk.ru, то есть после переноса путь
      // авторизации зависит лишь от нашего домена и доменов самого ВКонтакте.
      //
      // Версия прибита в имени файла: floating-диапазон @<3.0.0 когда-то
      // подтянул сломанную 2.6.6 (t is not a function), 2.6.5 — последняя
      // рабочая. Обновление = новый файл рядом, старый URL при этом не
      // кешируется поверх нового.
      script.src = '/vendor/vkid-sdk-2.6.5.js'
      script.async = true
      script.defer = true

      const self = this

      script.onload = () => {
        console.log('VK SDK loaded successfully')
        // Даем SDK время на инициализацию
        setTimeout(() => {
          self.initVKWidget()
        }, 100)
      }

      script.onerror = error => {
        console.error('Failed to load VK SDK:', error)
      }

      document.body.appendChild(script)
    }
  }
}
</script>
